import { render } from "./ConfirmarConta.vue?vue&type=template&id=1cf3d278"
import script from "./ConfirmarConta.vue?vue&type=script&lang=js"
export * from "./ConfirmarConta.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__